// Dashboard top search (auto-suggests accounts, clients and topics)
import AccountModule from "../../store/modules/account";
import {deepClone} from "@/helpers/helpers";
import {convertParamsObjectToQueryString} from "@/components/NewFilterBar/FilterBar";
import AppModule from "@/store/modules/app";

export default () => {
    // fixme :: todo :: const {merged_topics} = TopicModule();
    const {current_account} = AccountModule();
    const {navigateReload} = AppModule();

    const navigateSuggestedEntity = (item, keyword) => {
        let queryParameters = deepClone({
            dates_list: [
                new Date().formatSysDate(),
                new Date().formatSysDate(),
                "som_-1",
                "eom_0"
            ],
            keyword: "",
            task_status: [],
            topic_id_list: [],
            client_id_list: [],
            person_id_list: [current_account.value.id],
            columns: ["topic", "comments"],
            page: 1,
            itemsPerPage: 50,
            sortBy: "",
            sortDesc: false,
            groupBy: "", // [],
            groupDesc: [],
            multiSort: false,
            mustSort: false,
            searchMode: true
        })

        let topic_id = "";
        if (keyword) {
            keyword = keyword.replace('+', '%2B');
            queryParameters["keyword"] = keyword
        }
        if (item && item.type === "topic") {
            const found_merged = false; // fixme :: merged_topics.value.find(t => t.name === item.name);
            if (found_merged) {
                topic_id = String(found_merged.ids_str);
            } else {
                topic_id = String(item.topic_id);
            }
            queryParameters["topic_id_list"] = [topic_id]
        } else if (item && item.type === "client") {
            queryParameters["client_id_list"] = [item.client_id];
        }
        if (item && item.type === "account") {
            queryParameters["person_id_list"] = [item.account_id];
        }

        let qs = convertParamsObjectToQueryString(queryParameters)

        navigateReload(qs)
    };
    return {navigateSuggestedEntity};
};
